const actions = {
  GET_LOAD: 'GET_LOAD',
  GET_SUCCESS: 'GET_SUCCESS',
  GET_ERROR: 'GET_ERROR',

  getLoad: () => {
    return { type: actions.GET_LOAD };
  },
  getSuccess: (data) => {
    return { type: actions.GET_SUCCESS, data };
  },
  getErr: (err) => {
    return { type: actions.GET_ERROR, err };
  },

  ADD_MONITOR_BEGIN: 'ADD_MONITOR_BEGIN',
  ADD_MONITOR_SUCCESS: 'ADD_MONITOR_SUCCESS',
  ADD_MONITOR_ERROR: 'ADD_MONITOR_ERROR',

  addMonitorBegin: () => {
    return { type: actions.ADD_MONITOR_BEGIN };
  },

  addMonitorSuccess: (data) => {
    return { type: actions.ADD_MONITOR_SUCCESS, data };
  },

  addMonitorErr: (err) => {
    return { type: actions.ADD_MONITOR_ERROR, err };
  },

  GET_MONITOR_DETAIL_LOAD: 'GET_MONITOR_DETAIL_LOAD',
  GET_MONITOR_DETAIL_SUCCESS: 'GET_MONITOR_DETAIL_SUCCESS',
  GET_MONITOR_DETAIL_ERROR: 'GET_MONITOR_DETAIL_ERROR',

  getMonitorDetailLoad: () => {
    return { type: actions.GET_MONITOR_DETAIL_LOAD };
  },
  getMonitorDetailSuccess: (data) => {
    return { type: actions.GET_MONITOR_DETAIL_SUCCESS, data };
  },
  getMonitorDetailErr: (err) => {
    return { type: actions.GET_MONITOR_DETAIL_ERROR, err };
  },
};

export default actions;
